import axiosClient from './axios.client.js';

// Get all contacts
export const getContacts = async () => {
  try {
    const response = await axiosClient.get('/contacts');
    return response;
  } catch (error) {
    console.error('Error fetching contacts:', error);
    throw error;
  }
};

// Get a single contact by ID
export const getContact = async (id) => {
  try {
    const response = await axiosClient.get(`/contacts/${id}`);
    return response;
  } catch (error) {
    console.error('Error fetching contact:', error);
    throw error;
  }
};

// Create a new contact
export const createContact = async (contactData) => {
  try {
    const response = await axiosClient.post('/contacts', contactData);
    return response;
  } catch (error) {
    console.error('Error creating contact:', error);
    throw error;
  }
};

// Update an existing contact
export const updateContact = async (id, contactData) => {
  try {
    const response = await axiosClient.put(`/contacts/${id}`, contactData);
    return response;
  } catch (error) {
    console.error('Error updating contact:', error);
    throw error;
  }
};

// Delete a contact
export const deleteContact = async (id) => {
  try {
    const response = await axiosClient.delete(`/contacts/${id}`);
    return response;
  } catch (error) {
    console.error('Error deleting contact:', error);
    throw error;
  }
};

// Import contacts in bulk
export const importContacts = async (contactsData) => {
  try {
    const response = await axiosClient.post('/contacts/import', contactsData);
    return response;
  } catch (error) {
    console.error('Error importing contacts:', error);
    throw error;
  }
};

// Extract contact fields from text using AI
export const extractContactFields = async (transcript, provider = 'ollama') => {
  try {
    const response = await axiosClient.post('/contacts/extract-fields', {
      transcript,
      provider,
    });
    return response;
  } catch (error) {
    console.error('Error extracting contact fields:', error);
    throw error;
  }
};
